/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface VerifyEmailRequest {
  email: string;
  /**
     * @minLength 6
     * @maxLength 6
     * @pattern ^\d{6}$
     */
  code: string;
  pending_authentication_token?: string | null;
  organization_id?: string | null;
  comet_token?: string | null;
}
